import { render, staticRenderFns } from "./sellableItemList.vue?vue&type=template&id=4df18a80&scoped=true&"
import script from "./sellableItemList.vue?vue&type=script&lang=js&"
export * from "./sellableItemList.vue?vue&type=script&lang=js&"
import style0 from "./sellableItemList.vue?vue&type=style&index=0&id=4df18a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df18a80",
  null
  
)

export default component.exports